import React, { useState } from "react";
import { Dialog, useMediaQuery, useTheme } from "@material-ui/core";
import classNames from "classnames";
import { useForm } from "react-hook-form";
import { connect } from "react-redux";
import { yupResolver } from "@hookform/resolvers";
import { object, string } from "yup";

const inputClass =
  "appearance-none block w-full  border border-gray-400 rounded py-3 px-4 mb-3 leading-tight focus:outline-none bg-white focus:border-black";

const inputErrorClass = "border border-red-500 b-2 text-red-500";
const labelClass = "block tracking-wide text-black text-sm leading-5 mb-2";

const validationSchema = object().shape({
  spocName: string().required("SPOC name is required."),
  spocEmail: string()
    .email("Must be a valid Email ID.")
    .required("SPOC Email ID is required."),
});

const AddSpocModal = ({
  onSubmit,
  membershipId,
  user,
  membershipName,
  onCancel,
  modalProps,
}) => {
  const { register, handleSubmit, errors } = useForm({
    resolver: yupResolver(validationSchema),
  });
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const [acknowledged, setAcknowledged] = useState(false);

  return (
    <Dialog
      // classes={{ paper: { maxHeight: "100%" } }}
      fullScreen={fullScreen}
      {...modalProps}
    >
      <div className="rounded-lg px-8 py-12 w-full h-screen">
        {/* Modal Header */}
        <div className="space-y-2">
          <p className="uppercase text-xs leading-3 tracking-widest text-gray-600 font-bold"></p>
          <h3 className="text-4xl leading-10 font-bold">
            Add SPOC of {membershipName}{" "}
          </h3>
        </div>
        {/* Main Form Section */}
        <div className="mt-5">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="bg-formBackground -mx-8">
              <div className="px-8 py-4">
                <div className="sm:w-4/5 w-full mb-6">
                  <label className={labelClass} htmlFor="quantity">
                    Enter SPOC Email
                  </label>
                  <input
                    className={classNames({
                      [inputClass]: true,
                      [inputErrorClass]:
                        errors.spocEmail && errors.spocEmail.message,
                    })}
                    id="spocEmail"
                    type="email"
                    placeholder="Enter SPOC Email"
                    name="spocEmail"
                    ref={register}
                  />
                  {errors.spocEmail && errors.spocEmail.message && (
                    <div className="text-xs text-red-500 max-w-xs">
                      <span>{errors.spocEmail.message}</span>
                    </div>
                  )}
                </div>
                <div className="sm:w-4/5 w-full mb-6">
                  <label className={labelClass} htmlFor="spocName">
                    SPOC Name
                  </label>
                  <input
                    className={classNames({
                      [inputClass]: true,
                      [inputErrorClass]:
                        errors.spocName && errors.spocName.message,
                    })}
                    id="spocName"
                    type="text"
                    placeholder="SPOC NAME"
                    name="spocName"
                    ref={register}
                  />
                  {errors.spocName && errors.spocName.message && (
                    <div className="text-xs text-red-500 max-w-xs">
                      <span>{errors.spocName.message}</span>
                    </div>
                  )}
                </div>

                <div className="sm:w-4/5 w-full mb-6 space-x-4">
                  <input
                    id="confirmuser"
                    type="checkbox"
                    name="confirmuser"
                    checked={acknowledged}
                    onChange={() => setAcknowledged((val) => !val)}
                  />
                  {errors.spocName && errors.spocName.message && (
                    <div className="text-xs text-red-500 max-w-xs">
                      <span>{errors.spocName.message}</span>
                    </div>
                  )}
                  <label className="font-bold text-base" htmlFor="confirmuser">
                    Acknowledge action as {user.name}
                  </label>
                </div>
              </div>
            </div>
            <hr className="my-2 border-0 border-gray-100" />
            {/* Action Buttons */}
            <div className="flex items-center sm:flex-row-reverse flex-col sm:pl-8 py-6">
              <button
                className={classNames({
                  "text-center inline-block sm:ml-4 sm:mb-0 mb-4 px-16 shadow bg-themeYellow rounded-md py-4 uppercase font-bold text-sm tracking-widest leading-4 outline-none": true,
                  "opacity-25": !acknowledged,
                })}
                type="submit"
                disabled={!acknowledged}
              >
                Save
              </button>
              <button
                type="button"
                className="text-center inline-block bg-white px-16 shadow rounded-md py-4 uppercase font-bold text-sm tracking-widest leading-4 outline-none"
                onClick={onCancel}
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </Dialog>
  );
};

const mapStateToProps = (state) => ({
  user: state.auth.user,
});

export default connect(mapStateToProps)(AddSpocModal);
